import { CapitalizeFirstLetter } from '@cdab/headless-components'
import {
  TdsBadge,
  TdsNavigationTab,
  TdsNavigationTabs
} from '@scania/tegel-react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useSearchParams } from 'react-router-dom'
import { StyledNavLink } from './audit-point-tabs.styles'
import type { AuditPointTabsProps } from './audit-point-tabs.types'

export const SEARCH_PARAM_OPEN_PLEDGES_KEY = 'openPledges'

export const AuditPointTabs = (props: AuditPointTabsProps) => {
  const { numberOfDeviations, numberOfReferenceDocuments } = props
  const { t } = useTranslation()
  const location = useLocation()
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)
  const [searchParams] = useSearchParams({
    [SEARCH_PARAM_OPEN_PLEDGES_KEY]: []
  })

  function getLink(path: string) {
    const link = `${path}?${searchParams.toString()}`
    return link
  }

  const tabRoutes = [
    'status',
    'checkpoints',
    'deviations',
    'reference-documents',
    'attachments'
  ]

  useEffect(() => {
    const currentIndex = tabRoutes.findIndex(route =>
      location.pathname.endsWith(`/${route}`)
    )
    if (currentIndex !== -1) {
      setSelectedTabIndex(currentIndex)
    } else {
      setSelectedTabIndex(0)
    }
  }, [location.pathname])

  return (
    <TdsNavigationTabs selectedIndex={selectedTabIndex}>
      <TdsNavigationTab>
        <StyledNavLink to={getLink('status')}>
          <CapitalizeFirstLetter>{t('status')}</CapitalizeFirstLetter>
        </StyledNavLink>
      </TdsNavigationTab>
      <TdsNavigationTab>
        <StyledNavLink to={getLink('checkpoints')}>
          <CapitalizeFirstLetter>{t('checkpoints')}</CapitalizeFirstLetter>
        </StyledNavLink>
      </TdsNavigationTab>
      <TdsNavigationTab>
        <StyledNavLink to={getLink('deviations')}>
          <CapitalizeFirstLetter>{t('deviations')}</CapitalizeFirstLetter>
          <TdsBadge value={numberOfDeviations.toString()} size='lg' />
        </StyledNavLink>
      </TdsNavigationTab>
      <TdsNavigationTab>
        <StyledNavLink to={getLink('reference-documents')}>
          <CapitalizeFirstLetter>
            {t('reference-documents')}
          </CapitalizeFirstLetter>{' '}
          <TdsBadge value={numberOfReferenceDocuments.toString()} size='lg' />
        </StyledNavLink>
      </TdsNavigationTab>
      <TdsNavigationTab>
        <StyledNavLink to={getLink('attachments')}>
          <CapitalizeFirstLetter>{t('attachments')}</CapitalizeFirstLetter>
        </StyledNavLink>
      </TdsNavigationTab>
    </TdsNavigationTabs>
  )
}
